var _defs, _rect, _rect2, _text, _line, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#2c2416"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8b6f47"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    stroke: "#8b6f47",
    strokeWidth: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#ece3d2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 60,
    width: 1020,
    height: 480,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 122,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "start",
    letterSpacing: 2
  }, "base20.c")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 150,
    x2: 1110,
    y2: 150,
    stroke: "#cfc2b1",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 214,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "long to_decimal(const char *s)")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 262,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "{")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 310,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "    long n = 0;")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 358,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "    for (; *s; s++)")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 406,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "        n = n * 20 + digit(*s);")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 454,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "    return n;")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 502,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 40,
    fill: "#2c2416",
    xmlSpace: "preserve"
  }, "}")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 368,
    width: 56,
    height: 50,
    fill: "none",
    stroke: "#8b6f47",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioC);
export default __webpack_public_path__ + "static/media/portfolio-c.d9599165eb15aaac6c298176aaacc0c5.svg";
export { ForwardRef as ReactComponent };